import React, { Component } from 'react'
import { render } from 'react-dom'

import { InlineMath, BlockMath } from 'react-katex';

import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { dark, darcula } from 'react-syntax-highlighter/dist/esm/styles/prism';

import {
  Header,
} from 'semantic-ui-react'

import 'katex/dist/katex.min.css';

class Chapter200 extends Component {
  render() {
    return (
      <div className="base">

        <Header as='h1'>
        2. 市場理解と予測に役立つ数学ツール
        </Header>

　巻末解説2では、筆者たちがよく利用する6つのツールについて、具体例を踏まえて解説してくれています。実際のビジネスの場で必要になったらこれを参考にして適用すると良いでしょう。<br/>

<ol>
  <li>ガンマ・ポアソン・リーセンシーモデル</li>
      <p className="base">「最近いつ買ったか」、「最近いつ訪れたか」というデータ（最近の購入時期：Recency）から、相対的にどのブランド、どの施設、どの時期に資源を集中すべきか教えてくれます。</p>
  <li>負の二項分布  </li>
      <p className="base">消費者世帯パネルの自社ブランドのデータと、実際の売り上げ高との違いを補正してくれるツールです。予測時のトライアル率、リピート率、購入回数のベンチマークにも非常に有効という事です。</p>
  <li>カテゴリーの進出順位モデル</li>
      <p className="base">新しく作られたカテゴリーに、どの程度のシェアが取れるか教えてくれます。また、マーケティングの計画に基づくシェアのシミュレーションが出来ます。</p>
  <li>トライアルモデル・リピートモデル</li>
      <p className="base">コンセプト・テスト、コンセプト・ユース・テストのデータと世帯パネル・データを使い、新製品の発売①年目の売り上げを予測できます。</p>
  <li>平均購入額・量モデル (VPP Model: Volume per Purchase)</li>
      <p className="base">製品のサイズを決める手助けをしてくれます。</p>
  <li>デリシュレーNBDモデル</li>
      <p className="base">巻末解説1の1−6で説明した、教科書の表1−4のコルゲートの四半期購入率、四半期購入回数、100％ロイヤル顧客の割合の予測、NBDのカテゴリーKのデリシュレーSがどのような計算がされているか、その具体的な例が示されています。</p>
</ol>

      </div>
    )   
  }
}

export default Chapter200;
